import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar, FaSwimmingPool, FaHandSparkles, FaUser } from "react-icons/fa";
import { IoCalendarOutline, IoFastFoodOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { CgGym } from "react-icons/cg";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import Lightbox from "yet-another-react-lightbox-lite";
import "yet-another-react-lightbox-lite/styles.css";
import { MenuContext } from "../context/MenuContext";
import ScrollToTop from "../ScrollToTop";
import { TostMessageContext } from "../context/TostMessage";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaWifi,FaParking,FaSmokingBan } from "react-icons/fa";
import { TbBuildingAirport, TbEyeSpark } from "react-icons/tb";
import { MdOutlineBedroomParent, MdOutlineFamilyRestroom } from "react-icons/md";
import { ApartmentDetailsModal } from "../components/apartment_details";
// import { convert } from "../context/utils";

export default function Home() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [apartmentList, setApartmentList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const {state} = useLocation();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [images, setImages] = useState([]);
    const [apt_desc, setAptDesc] = useState('');
    const [apt_duration, setAptDuration] = useState('');
    const [apt_price, setAptPrice] = useState('');
    const [initialised, setInitialised] = useState(false);
    const [clashing_date, setClashingDate] = useState(false);
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [minCheckOut, setMinCheckOut] = useState(null);
    const {setTostMessage} = useContext(TostMessageContext)
    const [apartments, setApartments] = useState([]);
    const [selectedApartments, setSelectedApartments] = useState([])
    const [totalPrice, setTotalPrice] = useState(0);
    const [detailsModalId, setDetailsModalId] = useState('');
    const [viewApartmentDetails, setViewApartmentDetails] = useState(false);
    const [pageData, setPageData] = useState({})
    // const [index, setIndex] = useState(0);

    const openViewer = (index) => {
        setCurrentIndex(index);
        setIsViewerOpen(true);
    };

    const closeViewer = () => {
        setCurrentIndex(0);
        setIsViewerOpen(false);
    };

    // First image is large
    const mainImage = images[0];

    // Next four images
    const sideImages = images.slice(1, 5);

    // Extra images count
    const extraCount = images.length - 5;

    useEffect(() => {
      if (menuOpen) setMenuOpen(false);
      const { checkIn, checkOut } = getDefaultDates();
      setFormFields({...formFields, check_in: state?.check_in || checkIn, check_out: state?.check_out || checkOut, min_date: checkIn });
      setMinCheckOut(getNextDate(checkIn));

      setInitialised(true); // flag
    }, [])

    useEffect(() => {
        if (!initialised) return;   // ❌ ignore all other updates
        if (!formFields.min_date) return;

        getData();                  // ✅ runs ONLY once
        setInitialised(false);      // stop it from ever running again
    }, [formFields, initialised]);

    function formatDate(date) {
      return date.toISOString().split("T")[0];
    }

    function convert(amount) {
      if (cookies?.userProfile?.user_country == "NG") {
        return 'NGN ' + Number(amount).toLocaleString("en-US")
      } else {
        return 'US ' + Number(amount/cookies?.userProfile?.usd_exchange).toLocaleString("en-US")
      }
    }

    // useEffect(() => {
    //   convert(1000);
    // }, [])

    function getDefaultDates() {
      const today = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);

      return {
        checkIn: formatDate(today),
        checkOut: formatDate(tomorrow)
      };
    }

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/home.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setImages(response.data.data.branch_images)
                setAptDesc(response.data.data.branch_description)
                setAptDuration(response.data.data.duration);
                setApartments(response.data.data.apartments);
                setPageData(response.data.data)
            } else {

            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
        }
    }
  const getNextDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d.toISOString().split("T")[0];
  };

  function selectApt(apt_cat,apt_plan,apt_price,quantity,duration) {
    const selected = selectedApartments;
    const index = selected.findIndex(
      item => item.apt_cat === apt_cat
    );
    apt_price = apt_price*quantity*duration;

    if (index !== -1) {
      // Item exists
      if (quantity == 0) { 
        // Remove item
        console.log('remove', selected[index].apt_price)
        setTotalPrice(totalPrice-selected[index].apt_price)
        selected.splice(index, 1);
        setSelectedApartments(selected);
      } else {
        // Replace item
        setTotalPrice(totalPrice-selected[index].apt_price)
        selected[index] = {
          apt_cat,
          apt_plan,
          apt_price,
          quantity,
          duration
        };
        setTotalPrice(totalPrice+apt_price)
      }
    } else {
      // Item does not exist
      if (quantity > 0) {
        selected.push({
          apt_cat,
          apt_plan,
          apt_price,
          quantity,
          duration
        });
        setTotalPrice(totalPrice+apt_price)
      }
    }
  }

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      <ScrollToTop />
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
      {viewApartmentDetails &&
        <ApartmentDetailsModal
          setViewApartmentDetails={setViewApartmentDetails}
          setDetailsModalId={setDetailsModalId}
          apt_cat={detailsModalId}
        />
      }
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
        <div className="py-6 px-10 flex flex-col justify-start">
            <div className="flex items-center justify-start gap-x-3">
                <h2 className="text-2xl text-black font-bold">{pageData?.branch_name}</h2>
            </div>
            <div className="animate-fadeIn mt-5 w-full md:w-[fit-content] bg-white rounded-3xl border p-6 shadow-sm flex flex-col gap-6 md:flex-row md:items-end md:gap-8">
              {/* Apartment Type */}
              {/* <div className="flex-1">
                <label className="flex flex-col items-start gap-2 text-gray-500 text-sm mb-1">
                  <FaUserFriends className="w-5 h-5" />
                  <h2 className="text-md md:text-xl text-black font-semibold">{state?.apt_name}</h2>
                </label>
              </div> */}

              {/* Check-in */}
              <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                  <CiCalendar className="w-5 h-5" />
                  Check-in
                </label>

                <div className="flex items-center justify-between">
                  <input
                    type="date"
                    min={formFields?.min_date}
                    className="w-full bg-transparent focus:outline-none text-gray-700"
                    value={formFields?.check_in}
                    onChange={(e) => {setFormFields({...formFields, check_in: e.target.value, check_out: getNextDate(e.target.value)});setMinCheckOut(getNextDate(e.target.value)); }}
                  />
                </div>

                <div className="border-b border-black mt-1" />
              </div>

              {/* Check-out */}
              <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                  <CiCalendar className="w-5 h-5" />
                  Check-out
                </label>

                <div className="flex items-center justify-between">
                  <input
                    type="date"
                    className="w-full bg-transparent focus:outline-none text-gray-700"
                    value={formFields?.check_out}
                    min={minCheckOut}
                    onChange={(e) => setFormFields({...formFields, check_out: e.target.value})}
                  />
                </div>

                <div className="border-b border-black mt-1" />
              </div>

              {/* Button */}
              <button 
              onClick={() => getData()}
              className="
                  bg-[#037684] text-white rounded-full font-semibold
                  px-8 py-3 transition hover:bg-primary
                  w-full md:w-auto md:self-center
                ">
                Check Dates
              </button>
            </div>
            <div className="animate-scaleIn mt-8">
                <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4">
                    
                    {/* Large main image */}
                    <div 
                    className="md:col-span-2 rounded-2xl overflow-hidden cursor-pointer"
                    onClick={() => openViewer(0)}
                    >
                    <img 
                        src={images[0]} 
                        className="w-full h-64 sm:h-96 object-cover rounded-2xl" 
                        alt="Main"
                    />
                    </div>

                    {/* Right side 4 images */}
                    <div className="grid grid-cols-2 gap-4">
                    {sideImages.map((img, index) => {
                        const globalIndex = index + 1;

                        return (
                        <div
                            key={index}
                            className="relative rounded-2xl overflow-hidden cursor-pointer"
                            onClick={() => openViewer(globalIndex)}
                        >
                            <img 
                            src={img} 
                            className="w-full h-44 object-cover rounded-2xl" 
                            alt=""
                            />

                            {/* +X overlay on the last image */}
                            {index === 3 && extraCount > 0 && (
                            <div className="absolute h-44 rounded-2xl inset-0 bg-black/60 flex items-center justify-center text-white text-3xl font-semibold">
                                +{extraCount}
                            </div>
                            )}
                        </div>
                        );
                    })} 
                    </div>
                </div>
                {/* IMAGE VIEWER POPUP */}
                {isViewerOpen && (
                    <Lightbox
                        // open={isViewerOpen}
                        // close={() => setIsViewerOpen(false)}
                        slides={images.map(img => ({ src: img }))}
                        index={currentIndex}
                        setIndex={setCurrentIndex}
                    />
                )}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mt-10">
                  <div className="lg:col-span-2">
                      <h2 className="text-lg font-semibold mb-3">Description</h2>
              
                      <p className="text-md leading-relaxed text-[#303030]">
                      {apt_desc}
                      </p>
              
                      <h2 className="text-lg font-semibold mt-10 mb-3">Amenities</h2>

                      <section class="max-w-6xl mx-auto px-0 ">
                        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <CgGym size={20} />
                            <span class="text-sm font-medium">Well-Equipped Gym</span>
                          </div>
                      
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <FaHandSparkles size={20} />
                            <span class="text-sm font-medium">Spa</span>
                          </div>
                      
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <FaSwimmingPool size={20} />
                            <span class="text-sm font-medium">Swimming Pool</span>
                          </div>
                      
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <FaWifi size={20} />
                            <span class="text-sm font-medium">Free Wifi</span>
                          </div>
                      
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <FaParking size={20} />
                            <span class="text-sm font-medium">Free on-site parking</span>
                          </div>
                      
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-4 bg-white">
                            <TbBuildingAirport size={20} />
                            <span class="text-sm font-medium">Airport shuttle</span>
                          </div>
                      
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <TbEyeSpark size={20} />
                            <span class="text-sm font-medium">Best Views</span>
                          </div>
                          
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <MdOutlineFamilyRestroom />
                            <span class="text-sm font-medium">Family Apartments</span>
                          </div>
                          
                          <div class="flex items-center gap-4 border rounded-xl p-2 lg:p-3 bg-white">
                            <FaSmokingBan size={20} />
                            <span class="text-sm font-medium">Non-Smoking Rooms</span>
                          </div>
                      
                        </div>
                      </section>
              
                      <div className="max-w-5xl mx-auto py-10">

                          <h2 className="text-xl font-semibold">Policies</h2>
                          <div className="mt-6 bg-white rounded-xl shadow-sm border overflow-hidden">
                          
                              <div className="flex flex-col sm:flex-row border-b p-4">
                              <div className="flex items-start gap-3 w-full sm:w-1/3">
                                  <span className="text-xl"><i className="fa-regular fa-clock"></i></span>
                                  <span className="font-aileron-regular font-semibold text-sm">Check-In</span>
                              </div>
                              <div className="text-gray-700 text-sm mt-2 sm:mt-0 sm:w-2/3">
                                  Check-in starts from 15:00 (3PM) <br/>
                                  Early check-in is subject to availability and you will need to inform us ahead.
                              </div>
                              </div>
                      
                              <div className="flex flex-col sm:flex-row border-b p-4">
                              <div className="flex items-start gap-3 w-full sm:w-1/3">
                                  <span className="text-xl"><i className="fa-regular fa-clock"></i></span>
                                  <span className="font-aileron-regular font-semibold text-sm">Check-Out</span>
                              </div>
                              <div className="text-gray-700 text-sm mt-2 sm:mt-0 sm:w-2/3">
                                  Check-out end by 12:00 (12PM) <br/>
                                  Late check-out is subject to availability and you will need to inform us ahead.
                              </div>
                              </div>
                          
                              <div className="flex flex-col sm:flex-row border-b p-4">
                              <div className="flex items-start gap-3 w-full sm:w-1/3">
                                  <span className="text-xl"><i className="fa-solid fa-ban"></i></span>
                                  <span className="font-aileron-regular font-semibold text-sm">Cancellation</span>
                              </div>
                              <div className="text-gray-700 text-sm mt-2 sm:mt-0 sm:w-2/3">
                                  Cancellation and prepayment policies vary according to booking type.
                                  Please check what conditions may apply to each option when making your selection.<br/>
                                  <a className="font-aileron-regular font-semibold tet-sm text-secondary" href="https://riverrunresidence.com/cancellation/">Read our policy</a>
                              </div>
                              </div>
                          
                              <div className="flex flex-col sm:flex-row border-b p-4">
                              <div className="flex items-start gap-3 w-full sm:w-1/3">
                                  <span className="text-xl"><i className="fa-solid fa-ban-smoking"></i></span>
                                  <span className="font-aileron-regular font-semibold text-sm">Smoking</span>
                              </div>
                              <div className="text-gray-700 text-sm mt-2 sm:mt-0 sm:w-2/3">
                                  Smoking not allowed in the apartment.
                              </div>
                              </div>
                          
                              <div className="flex flex-col sm:flex-row p-4">
                              <div className="flex items-start gap-3 w-full sm:w-1/3">
                                  <span className="text-xl"><i className="fa-solid fa-dog"></i></span>
                                  <span className="font-aileron-regular font-semibold text-sm">Pets</span>
                              </div>
                              <div className="text-gray-700 text-sm mt-2 sm:mt-0 sm:w-2/3">
                                  Pets are not allowed.
                              </div>
                              </div>
                          
                          </div>
                      </div>
                  </div>
              
                  <div className="h-[min-content] sticky top-0">
                      <div className="bg-white rounded-xl shadow-md">
                          <div className="w-full h-72 rounded-xl overflow-hidden">
                          <iframe
                              className="w-full h-full"
                              src="https://www.google.com/maps?q=6+Elsie+Femi+Pearse+St,+Victoria+Island,+Lagos+106104,+Lagos&t=&z=13&ie=UTF8&iwloc=&output=embed">
                          </iframe>
                          </div>
                      </div>
                      {/* <div className="flex flex-col items-center mt-5">
                          <button onClick={() => !clashing_date ? navigate(`/dashboard/make-payment/${state.apt}`, { state: {apt: state.apt, apt_name: state.apt_name, check_in: formFields?.check_in, check_out: formFields?.check_out }}) : setTostMessage({ messageType: 'warning', message: 'This unit is not available on your selected dates' }) } className="bg-primary text-white flex flex-row items-center justify-evenly w-full h-[50px] px-5 rounded-2xl shadow-md shrink-0 text-lg font-aileron-bold">
                              <span className="text-white font-aileron-bold text-lg update-price">Book Now: {apt_price}</span>
                          </button>
                          <span className="text-[#C4A17A] font-aileron-bold text-md mt-2 update-nights">{apt_duration} Night(s)</span>
                      </div> */}
                  </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mt-10">
                  <section className="lg:col-span-2">
                      <div class="grid grid-cols-1 lg:grid-cols-3 bg-[#447379] text-white text-sm font-semibold rounded-t-lg">
                        <div class="p-3 text-md hover:bg-[#003a41] hidden lg:block">Apartment Type</div>
                        <div class="p-3 text-md hover:bg-[#003a41] hidden lg:block">Guests</div>
                        <div class="p-3 text-md hover:bg-[#003a41] hidden lg:block">Price Plans</div>
                        <div class="p-3 text-md hover:bg-[#003a41] block lg:hidden">Apartments</div>
                      </div>
                    
                      <div class="border lg:border-0 border-[#447379] search_results">
                        {apartments?.map((apartment, index) => 
                        <div class="border-b lg:border-0 border-[#447379] grid grid-cols-1 lg:grid-cols-3">
                            
                          <div class="p-2 lg:p-4 space-y-2 border-0 lg:border border-[#447379]">
                            <h3 onClick={() => {setViewApartmentDetails(true); setDetailsModalId(apartment?.apt_cat)}} class="text-blue-700 font-semibold underline cursor-pointer open_apt_details">{apartment?.apt_name}</h3>
                            <div class="flex flex-col flex-wrap items-start justify-start">
                              <div className="flex flex-row items-center">
                                <MdOutlineBedroomParent size={15} />
                                <a class="text-sm"><i class="fa-solid fa-bed mr-1"></i> {apartment?.bedrooms} Bedroom(s)</a>
                              </div>
                              <div className="flex flex-row flex-wrap items-center">
                                {apartment?.beds_arr?.map((bed, index) => 
                                <p class="text-sm my-1">{bed.quantity} {bed.bed_type} ● </p>
                                )}
                              </div>
                            </div>
                            <p class="text-red-600 text-sm">● Only {apartment?.apt_left} left</p>
                            
                            <div class="flex flex-wrap gap-2 text-xs text-gray-600">
                                {apartment?.amenities_arr?.map((item, index) => 
                                <span class="border px-2 py-1 rounded">{item}</span>
                                )}
                            </div>
                          </div>
                    
                          <div class="p-2 flex lg:p-4 text-sm gap-x-1 border-0 lg:border border-[#447379]">
                              <div className="flex flex-row flex-wrap items-start justify-start">
                                {Array.from({ length: apartment.guest_count }).map((_, i) => (
                                  <FaUser size={20} />
                                ))}
                                <p className="text-lg font-semibold ml-2">({apartment.guest_count})</p>
                              </div>
                          </div>
                    
                          <div class="">
                            {apartment?.apt_plans?.map((plan, index) => 
                            <div class="border border-0 lg:border border-[#447379] p-2 lg:p-4 gap-y-2"> 
                                <p class="font-aileron-semibold text-md">{convert(plan.amount)} <a class="font-semibold text-md underline">({plan.plan_title})</a></p>
                                <ul class="mb-1">
                                    <li class="text-green-600 text-sm">{plan.plan_benefits}</li>
                                </ul>
                                <div class="flex flex-row items-center py-1 space-x-3">
                                    <p>Add:</p>
                                    <select onChange={(e) => selectApt(apartment.apt_cat,plan.plan_id,plan.amount,e.target.value,apartment?.duration)} class="border rounded p-1 w-full pricing_plan">
                                      <option>0</option>
                                      {Array.from({ length: apartment.apt_left }).map((_, i) => (
                                      <option>{++i}</option>
                                      ))}
                                    </select>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                        )}
                      </div>
                    
                    </section>
                        <div className="h-[min-content] sticky top-0">
                          <div class="w-full text-sm bg-white rounded-xl shadow-md p-6 space-y-6">
                                <div class="border rounded-lg p-4 text-[15px] lg:text-[18px]">
                                  <div class="flex justify-between">
                                    <div>
                                      <p class="text-black font-aileron-regular font-semibold text-sm">Check-In</p>
                                      <p class="font-aileron-medium text-sm lg:text-md check_in_display">{formFields?.check_in}</p>
                                    </div>
                                    <div>
                                      <p class="text-black font-aileron-regular font-semibold text-sm">Check-Out</p>
                                      <p class="font-aileron-medium text-sm lg:text-md check_out_display">{formFields?.check_out}</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex flex-col selected_apts gap-y-1">
                                    {selectedApartments?.map((item, index) => {
                                      return (
                                        <div class="flex flex-row justify-between">
                                            <a class="text-md font-semibold">{item.apt_cat}</a>
                                            <div class="flex flex-col items-end">
                                                <a class="text-md font-semibold">{convert(item.apt_price)}</a>
                                                <a class="text-sm">{item.quantity} apts.</a>
                                            </div>
                                        </div>
                                      )
                                    })}
                                </div>
                                <a class="text-sm lg:text-md font-aileron-regular font-bold mx-auto total_amount">Total: {convert(totalPrice)}</a>
                                <div class="p-2 lg:-4 space-y-3">
                                    <p>Selected rooms will appear here</p>
                                    <button onClick={() => selectedApartments?.length > 0 ? navigate(`/dashboard/make-payment/`, { state: {selectedApartments: selectedApartments, check_in: formFields?.check_in, check_out: formFields?.check_out }}) : setTostMessage({ messageType: 'warning', message: 'Please select an apartment' }) } class="bg-[#003a41] text-white w-full py-2 rounded text-sm book_now_btn">
                                      Book Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
  );
}
